import { useState } from 'react';
import t1 from '../assets/testimonials/t1.png';
export function ImgOrPh({ src, className, style, phIcon, phText, imgStyle }) {
  const [err, setErr] = useState(false);
  if (src && !err) {
    return <img src={src} className={className} style={style || imgStyle} alt={phText} onError={() => setErr(true)} />;
  }
  return (
    <div className={className} style={style}>
      <div className={`${className}-ph`} style={imgStyle}>
        <span className="ph-icon">{phIcon}</span>
        <span className="ph-txt">{phText}</span>
      </div>
    </div>
  );
}

export function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' open' : ''}`}>
      <div className="faq-q" onClick={() => setOpen(o => !o)}>
        <span>{q}</span>
        <div className="faq-toggle">{open ? '−' : '+'}</div>
      </div>
      {open && <div className="faq-a"><br />{a}</div>}
    </div>
  );
}

export function TestiCard({ name, img }) {
  return (
    <div className="" style={{height : '150px' , overflow : 'hidden'}}  >
      <img src={img} style={{width: '100%' , objectFit : 'contain'}} alt={name} />
      {/* <div className="testi-stars">★★★★★</div>
      <div className="testi-quote">"</div>
      <p className="testi-text">{text}</p>
      <div className="testi-author">
        <div className="testi-av">{name.charAt(0)}</div>
        <div>
          <div className="testi-name">{name}</div>
          <div className="testi-role">{role}</div>
        </div>
      </div> */}
    </div>
  );
}
